import { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import './BarraBuscaComTodasUnidades.css';

import lupaIcon from '../../imagens/lupaIcon.png'

import { servGetAllEstabelecimentos, servGetEstabelecimentoPorNome } from '../../servicos/estabelecimento';
import toast from 'react-hot-toast';
import SpinnerLoading from '../SpinnerLoading';
import { useClickOutside } from '../../hooks/clickOutside';

function BarraBuscaComTodasUnidades({ setEstabelecimento, somenteAtivos, enviaRelatorioAcompanhamento }) {

  const [opcaoSelecionada, setOpcaoSelecionada] = useState(null);
  // Assim que monta o componente já busca todas as unidades pra exibir caso o usuário queira
  const [allEstabelecimentos, setAllEstabelecimentos] = useState(null);
  const [resultadoBusca, setResultadoBusca] = useState([]);
  const [loading, setLoading] = useState(false);
  const [controladorValueInput, setControladorValueInput] = useState('');

  const monitoraCliqueFora = useRef(null);

  useEffect(() => {
    getAllEstabelecimentos()
  }, []);

  useClickOutside(monitoraCliqueFora, () => limparResultadoBusca());

  const handleChange = async (evento) => {
    const value = evento.target.value;
    setControladorValueInput(value)
    if (value.length >= 3) {
      try {
        setLoading(true);
        const estabelecimentosDaApi = await servGetEstabelecimentoPorNome(value, somenteAtivos, enviaRelatorioAcompanhamento)
        setResultadoBusca(estabelecimentosDaApi)
      } catch (erro) {
        toast.error(erro.message)
        console.log(erro);
      } finally {
        setLoading(false);
      }
    }
  };

  const handleSelect = (estabelecimento) => {
    setEstabelecimento(estabelecimento);
    setOpcaoSelecionada(estabelecimento.nome);
    setResultadoBusca([])
  };

  async function getAllEstabelecimentos() {
    try {
      const estabelecimentosDaApi = await servGetAllEstabelecimentos(somenteAtivos, enviaRelatorioAcompanhamento);
      setAllEstabelecimentos(estabelecimentosDaApi);
    } catch (erro) {
      console.log(erro);
      toast.error('Não foi possível carregar as unidades na barra de busca')
    }
  }

  const limparResultadoBusca = () => {
    setResultadoBusca([])
  };

  const listarTudo = () => {
    if (!resultadoBusca) toast.error('Problema ao listar estabelecimentos/unidades')
    setResultadoBusca(allEstabelecimentos)
  };

  const resetInfo = () => {
    setEstabelecimento(null)
    setOpcaoSelecionada(null)
  };

  return (
    <div className='container-fluid d-flex flex-column flex-md-row p-0 gap-2 align-items-center' ref={monitoraCliqueFora}>
      <div className="w-100 position-relative">
        <div className='input-and-lupa d-flex '>
          <input
            className='form-control text-center'
            value={controladorValueInput}
            onChange={handleChange}
            onBlur={() => setControladorValueInput('')}
            placeholder={opcaoSelecionada || 'Unidade não selecionada'} />
        </div>
        <div className='resultado-busca-container position-absolute'>
          {loading ?
            <div className='div-com-borda p-1'>
              <SpinnerLoading mensagemLoading='Carregando' />
            </div>
            : resultadoBusca && (
              <ul className="resultado-busca text-center list-group mt-1" // position-absolute list-group-item
                style={{ zIndex: 1000 }}
              >
                {resultadoBusca.map((estabelecimento) => (
                  <li className='resultado-busca-item p-2' key={estabelecimento.id} onClick={() => handleSelect(estabelecimento)} >
                    {estabelecimento.nome}
                  </li>
                ))}
              </ul>
            )
          }
        </div>
      </div>
      <img src={lupaIcon} alt="Icone Lupa" className="ms-1" style={{ 'width': '2em' }}></img>
      <div className='d-flex justify-content-center gap-3'>
        <button className='text-nowrap btn btn-primary' type='button' onClick={listarTudo}>LISTAR TUDO</button>
        <button className='text-nowrap btn btn-primary' type='button' onClick={resetInfo}>LIMPAR</button>
      </div>
    </div>
  );
};

export default BarraBuscaComTodasUnidades;

BarraBuscaComTodasUnidades.propTypes = {
    setEstabelecimento: PropTypes.func.isRequired,
    somenteAtivos: PropTypes.bool.isRequired,
    enviaRelatorioAcompanhamento: PropTypes.bool.isRequired
};